import type { GlyphKind } from '../../../types/glyph';

/**
 * Classifies a raw glyph string into its rendering kind.
 * - `set:name` (contains colon) → 'iconify'
 * - anything else (single char, plain text, null/empty) → 'letter'
 *
 * The glyph system stores only Iconify names. PrimeIcon (`pi-*`) is NOT a glyph
 * kind — PrimeIcons are used for app chrome only, rendered directly as
 * `<i className="pi …">`, never through this primitive. Legacy schema-avatar CSS
 * classes are normalized to Iconify names upstream (see normalizeLegacyGlyph).
 */
export function resolveGlyph(glyph: string | null | undefined): GlyphKind {
  if (!glyph) return 'letter';
  if (glyph.includes(':')) return 'iconify';
  return 'letter';
}
